module.exports = __webpack_public_path__ + "img/sold-out.cf1bfa71.png";